<template>
  <label
    class="transition-ease-in-out flex cursor-pointer items-center justify-between space-x-8 rounded-[20px] bg-white py-7 px-6 shadow-lightgray hover:bg-slate-50"
    :class="isChecked ? 'border-main border' : ''"
  >
    <div class="flex flex-row items-center justify-center gap-2">
      <div
        v-if="img != null"
        class="flex h-10 w-10 items-center justify-center rounded-full bg-slate-100"
      >
        <img :src="img" alt="" class="h-5 w-5" />
      </div>
      <slot> {{ $t("homepage." + label) }} </slot>
    </div>
    <input
      type="radio"
      :checked="isChecked"
      :value="value"
      @change="$emit('update:modelValue', $event.target.value)"
      class="text-main border-main transition-ease-in-out form-radio h-4 w-4 border-opacity-50 focus:ring-transparent"
      name="RadioImage"
    />
  </label>
</template>

<script>
export default {
  name: "RadioInput",
  props: {
    modelValue: {
      type: [String, Number, null],
      default: null,
    },
    value: {
      type: [String, Number, null],
      default: null,
    },
    label: {
      type: String,
      default: null,
    },
    img: {
      type: String,
      default: null,
    },
  },
  emit: ["update:modelValue"],
  computed: {
    isChecked() {
      return this.modelValue == this.value;
    },
  },
};
</script>
